import { render, staticRenderFns } from "./SettingsRemoteConnectionNew.vue?vue&type=template&id=4dabd3c3"
import script from "./SettingsRemoteConnectionNew.vue?vue&type=script&lang=js"
export * from "./SettingsRemoteConnectionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports